import Vue from 'vue';
import { mapGetters } from 'vuex';
import _ from 'lodash';

export default Vue.component('input-number', {
  template: require('./template.html'),
  name: 'input-number',
  computed: {
    ...mapGetters(['viewport', 'activeDroplet', 'activeDropletItem']),
    allColumns() {
      let list = [];
      const droplet = this.activeDroplet;
      if (droplet.rows) {
        _.forEach(this.activeDroplet.rows,
          row => _.forEach(row.columns, column => list.push(column)));
      }
      if (droplet.cards) {
        list = list.concat(droplet.cards);
      }
      if (droplet.columns) {
        list = list.concat(droplet.columns);
      }
      return { list };
    },
  },
  props: [
    'option',
    'active-state',
    'dom-nodes',
    'component-config',
  ],
  data() {
    return {
      display: {},
      debTime: 250,
      innerDomNodes: {},
    };
  },
  watch: {
    viewport() {
      this.setInitialValue();
    },
    activeState() {
      this.setInitialValue();
    },
    activeDropletItem: {
      handler() {
        this.setInitialValue();
      },
      deep: true,
    },
  },
  created() {
    // setup defaults from payload models
    _.forOwn(this.option.payload.models, (model) => {
      this.$set(this.display, model.name, model.default);
    });
    // then check for previous values
    this.setInitialValue();
  },
  methods: {
    setInitialValue() {
      const option = this.option;
      const payload = {
        $vm: {
          viewport: this.viewport,
          currentVal: null,
          droplet: this.activeDroplet,
        },
      };
      if (option.$el) {
        const useRoot = option.$el === 'root';
        const $root = this.domNodes.$dropletRow;
        payload.$el = useRoot ? $root : $root.querySelectorAll(option.$el)[0];
      }
      const rule = option.payload.updates[0];
      let selector;
      if (this.activeDropletItem._id && this.componentConfig.itemList) {
        const inner = this.componentConfig.itemList.selectors[rule.property];
        const nested = inner || '';
        selector = `#drp-${this.activeDropletItem._id}${nested}${this.activeState}`;
      } else {
        selector = rule.selector.replace(/\$\{state\}/gi, this.activeState);
        selector = selector.replace(/\$\{dropletId\}/gi, this.activeDroplet._id);
      }
      payload.selector = selector;
      payload.property = rule.property;
      payload.defaultUnit = option.payload.models.unit.default;
      const values = this._getVal(payload);
      // set local data
      this.display[option.payload.models.value.name] = values.val;
      this.display[option.payload.models.unit.name] = values.unit;
    },
    changeCSS(params) {
      const payload = {};
      payload.drp = this.activeDroplet;
      payload.val = this.buildVal(params);
      payload.viewport = this.viewport;
      // we only want to show updates to the dom if in default state
      if (this.activeState === '') {
        const properties = params.updates.map(item => item.local || item.property);
        this.setLocals({ ...payload, properties });
      }
      this._debounce(() => {
        _.forEach(params.updates, (item) => {
          let selector;
          if (this.activeDropletItem._id && this.componentConfig.itemList) {
            // this is in the event a user is targeting a specific item within a droplet
            // eg, a nav link or a column in columns
            let nested = '';
            const itemProperties = this.componentConfig.itemList.properties;
            if (itemProperties) {
              nested = itemProperties[item.selector].selector || '';
            } else {
              nested = this.componentConfig.itemList.selectors[item.property] || '';
            }
            const defaultSel = `#drp-${this.activeDropletItem._id}${nested}`;
            selector = `${defaultSel}${this.activeState}`;
          } else {
            this.resetCustomQueries(item);
            selector = item.selector.replace(/\$\{state\}/gi, this.activeState);
            selector = selector.replace(/\$\{dropletId\}/gi, this.activeDroplet._id);
          }
          payload.property = item.property;
          payload.selector = selector;
          this.$emit('check-legacy-styles', payload);
          this.$store.dispatch('changeDropletCss', payload);
        });
        this.$emit('css-generator', this.cssPayload(), this.option.plugin);
        this.$emit('update-changes', true);
        this.setLocals({ val: null, properties: [] });
      }, this.debTime);
    },
    resetCustomQueries(update) {
      if (!this.componentConfig.itemList) {
        return;
      }
      const inner = this.componentConfig.itemList.selectors[update.property];
      const nested = inner || '';
      const customRule = new RegExp(`#drp-[a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12}${nested}`, 'gi');
      _.forEach(this.activeDroplet.mediaQueries, (rule) => {
        if (rule.selector.match(customRule)) {
          const property = _.find(rule.properties, r => r.property === update.property);
          if (property) {
            this.$store.dispatch('setDropletVal', {
              drp: property,
              key: this.viewport,
              val: 'default',
            });
          }
        }
      });
    },
    buildVal(params) {
      const value = this.display[params.models.value.name];
      const unit = this.display[params.models.unit.name];
      return `${value}${unit}`;
    },
    cssPayload() {
      let payload = false;
      if (this.option.payload.useColumns) {
        payload = {
          key: 'drps',
          value: [...this.allColumns.list, this.activeDroplet],
        };
      }
      return payload;
    },
    setLocals(params) {
      this.$store.dispatch('setLocalStyles', params);
    },
  },
});



// WEBPACK FOOTER //
// ./src/global-view/editor/page/style-sidebar/options/input-number/index.js